module.exports = __webpack_public_path__ + "img/Body_feathers_MetalRoughness.79a50e9.jpg";